import React, { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { associatedProducts, associatedProductsContainer } from 'styles/components/productdetail/recosDetail.scss';
import Recos from 'components/productdetail/Recos';
import { shouldRecosUpdate } from 'helpers/RecoUtils';

export default class RecosDetail3 extends Component {

  // We don't want this component to re-render when it's either loading, or similarProductRecos haven't changed
  shouldComponentUpdate(nextProps) {
    return shouldRecosUpdate(this.props, nextProps);
  }

  render() {
    const {
      similarProductRecos: {
        janus = {},
        lastReceivedRecoKey
      } = {},
      heartsData, onRecoClicked
    } = this.props;
    // If we have recommendations, render the component.
    const janusData = janus[lastReceivedRecoKey] || {};
    const janusRecos = janusData['detail-ext-search-2'] || janusData['detail-3'];
    if (janusRecos) {
      const { title, recos } = janusRecos;
      return (
        <div className={cn(associatedProducts, associatedProductsContainer)}>
          <Recos
            recoType="subRecos"
            title={title}
            recos={recos}
            onRecoClicked={onRecoClicked}
            heartsData={heartsData} />
        </div>
      );
    }
    return null;
  }
}

RecosDetail3.propTypes = {
  params: PropTypes.object.isRequired,
  similarProductRecos: PropTypes.object.isRequired,
  styleId: PropTypes.string.isRequired
};

